import { connectRouter } from "connected-react-router";
import app3, * as fromApp3 from "./app3";
import locale3, * as fromLocale3 from "./locale3";
import view3, * as fromView3 from "./view3";
import data3, * as fromData3 from "./data3";
import ui3, * as fromUI3 from "./ui3";
import form3, * as fromForm3 from "./form3";
import user3, * as fromUser3 from "./user3";
import effect3, * as fromEffect3 from "./effect3";

/**
 * We do not use combineReducers as we sometimes need the states in other reducers
 *
 * ref: https://stackoverflow.com/questions/34419809/redux-is-there-any-way-to-access-store-tree-in-reducer
 */
const reducers = (history) => {
  return (state = {}, action) => {
    return {
      router: connectRouter(history)(),
      app3: app3(state.app3, action, state),
      locale3: locale3(state.locale3, action, state),
      view3: view3(state.view3, action, state),
      data3: data3(state.data3, action, state),
      ui3: ui3(state.ui3, action, state),
      form3: form3(state.form3, action, state),
      user3: user3(state.user3, action, state),
      effect3: effect3(state.effect3, action, state),
    };
  };

  // Previous code.
  // return combineReducers({
  //   router: connectRouter(history),
  //   app3,
  //   locale3,
  //   view3,
  //   data3,
  //   ui3,
  //   form3,
  //   user3,
  //   effect3
  // })
};

export default reducers;

/**
 * GETTERS
 */

// app3
export const getInitApp3Success = (state) =>
  fromApp3.getInitApp3Success(state.app3);
export const getConfiguration3 = (state) =>
  fromApp3.getConfiguration3(state.app3);
export const getError = (state) => fromApp3.getError(state.app3);
export const getWarning = (state) => fromApp3.getWarning(state.app3);
export const getHTMLTemplates3 = (state) =>
  fromApp3.getHTMLTemplates3(state.app3);
export const getResumeTicket = (state) => fromApp3.getResumeTicket(state.app3);
export const getPageTitle = (state) => fromApp3.getPageTitle(state.app3);
export const getIsOffline = (state) => fromApp3.getIsOffline(state.app3);
export const getModalContent = (state) => fromApp3.getModalContent(state.app3);

// locale3
export const getLocale3 = (state) => fromLocale3.getLocale3(state.locale3);
export const getLocale3Data = (state) =>
  fromLocale3.getLocale3Data(state.locale3);

// view3
export const getView3Loading = (state) =>
  fromView3.getView3Loading(state.view3);
export const getView3Nodes = (state) => fromView3.getView3Nodes(state.view3);
export const getView3Id = (state) => fromView3.getView3Id(state.view3);
export const getView3TemplateId = (state) =>
  fromView3.getView3TemplateId(state.view3);
export const getView3Data = (state) => fromView3.getView3Data(state.view3);

// data
export const getDataset3 = (state) => fromData3.getDataset3(state.data3);
export const getDataset3Loading = (state) =>
  fromData3.getDataset3Loading(state.data3);
export const getPubSub3 = (state) => fromData3.getPubSub3(state.data3);
export const getUploads = (state) => fromData3.getUploads(state.data3);
// export const getSearchResult3 = state => fromData3.getSearchResult3(state.data3);

// ui
export const getIsInputDisabled = (state) =>
  fromUI3.getIsInputDisabled(state.ui3);
export const getErrors = (state) => fromUI3.getErrors(state.ui3);
export const getWarnings = (state) => fromUI3.getWarnings(state.ui3);
export const getSuccess = (state) => fromUI3.getSuccess(state.ui3);
export const getLastStatusChange = (state) =>
  fromUI3.getLastStatusChange(state.ui3);

// form
export const getForm3Loading = (state) =>
  fromForm3.getForm3Loading(state.form3);
export const getForm3Nodes = (state) => fromForm3.getForm3Nodes(state.form3);
export const getForm3Id = (state) => fromForm3.getForm3Id(state.form3);
export const getForm3ActiveSection = (state) =>
  fromForm3.getForm3ActiveSection(state.form3);
export const getForm3Data = (state) => fromForm3.getForm3Data(state.form3);
export const getForm3Connections = (state) =>
  fromForm3.getForm3Connections(state.form3);
export const getForm3Validations = (state) =>
  fromForm3.getForm3Validations(state.form3);
export const getForm3ValidationErrors = (state) =>
  fromForm3.getForm3ValidationErrors(state.form3);
export const getForm3State = (state) => fromForm3.getForm3State(state.form3);
export const getForm3Closed = (state) => fromForm3.getForm3Closed(state.form3);
export const getForm3ValidationMessage = (state) =>
  fromForm3.getForm3ValidationMessage(state.form3);
export const getForm3Stop = (state) => fromForm3.getForm3Stop(state.form3);
export const getForm3Attachments = (state) =>
  fromForm3.getForm3Attachments(state.form3);
export const getForm3Error = (state) => fromForm3.getForm3Error(state.form3);
export const getForm3Process = (state) =>
  fromForm3.getForm3Process(state.form3);
export const getZeroIds = (state) => fromForm3.getZeroIds(state.form3);
export const getFormDataId = (state) => fromForm3.getFormDataId(state.form3);

// user3
export const getIsAuthenticated = (state) =>
  fromUser3.getIsAuthenticated(state.user3);
export const getAuthStatus = (state) => fromUser3.getAuthStatus(state.user3);
export const getUser = (state) => fromUser3.getUser(state.user3);
export const getUserPersistentProfile = (state) =>
  fromUser3.getUserPersistentProfile(state.user3);
export const getLoginSession = (state) =>
  fromUser3.getLoginSession(state.user3);
export const getSignSession = (state) => fromUser3.getSignSession(state.user3);

// effect3
export const getEffects = (state) => fromEffect3.getEffects(state.effect3);
export const getEffectsLoading = (state) =>
  fromEffect3.getEffectsLoading(state.effect3);
